import React from 'react';
import { SEGMENTS } from '../../hooks/useSignupWizard';

interface StepSegmentProps {
    formData: {
        segment: string;
    };
    updateFormData: (data: { segment: string }) => void;
    onNext: () => void;
    onBack: () => void;
    error: string | null;
}

const StepSegment: React.FC<StepSegmentProps> = ({
    formData,
    updateFormData,
    onNext,
    onBack,
    error
}) => {
    const handleSelect = (segmentId: string) => {
        updateFormData({ segment: segmentId });
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        onNext();
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-6">
            <div className="text-center mb-8">
                <p className="text-sm text-primary font-medium mb-2">Informações adicionais</p>
                <h2 className="text-2xl font-bold text-gray-900">Segmento do negócio</h2>
            </div>

            {error && (
                <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
                    {error}
                </div>
            )}

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                {SEGMENTS.map((segment) => (
                    <button
                        key={segment.id}
                        type="button"
                        onClick={() => handleSelect(segment.id)}
                        className={`
                            flex flex-col items-center justify-center p-4 rounded-xl border-2 transition-all hover:shadow-md
                            ${formData.segment === segment.id
                                ? 'border-primary bg-primary/5'
                                : 'border-gray-200 hover:border-gray-300'
                            }
                        `}
                    >
                        <span className="material-symbols-outlined text-3xl mb-2 text-gray-600">
                            {segment.icon}
                        </span>
                        <span className="text-sm font-medium text-gray-700 text-center">
                            {segment.label}
                        </span>
                    </button>
                ))}
            </div>

            <button
                type="submit"
                disabled={!formData.segment}
                className="w-full py-3 px-4 bg-primary hover:bg-primary-dark text-white font-semibold rounded-xl transition-all shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
            >
                Continuar
            </button>
        </form>
    );
};

export default StepSegment;
